// extracted by mini-css-extract-plugin
module.exports = {"link":"_2qHCb","icon":"_3gTzf"};